import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const STORAGE_KEY = 'bf-portal-cookie-consent';

interface CookieConsentState {
  /** Whether the notice has been accepted; once true it never shows again (PP-027). */
  readonly accepted: boolean;
  accept: () => void;
}

/**
 * Whether the cookie notice has been accepted (PP-027).
 *
 * localStorage, not sessionStorage: the requirement is that accepting it stops it coming back, and a
 * per-tab store would show it again on the next visit. It is the one preference the portal keeps
 * across sessions besides the theme.
 *
 * UI state only. It records a single boolean — no identifier, nothing about who accepted, and no PHI
 * (PP-027 AC-005).
 */
export const useCookieConsentStore = create<CookieConsentState>()(
  persist(
    (set) => ({
      accepted: false,
      accept: (): void => {
        set({ accepted: true });
      },
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
